import { comments } from '@/mocks/homeMocks';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2 scroll-mt-20">
            读者评价
          </h2>
          <p className="text-sm text-foreground-600 mb-6">
            来自漫画迷们的真实使用感受
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {comments.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm text-foreground-950 truncate">{item.name}</p>
                    <p className="text-xs text-foreground-500">{item.date}</p>
                  </div>
                  <div className="ml-auto flex items-center gap-0.5 shrink-0">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < item.rating
                            ? 'text-secondary-500 ri-star-fill'
                            : 'text-foreground-300 ri-star-line'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
                <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}